import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,ViewEntity, ViewColumn} from "typeorm";
import {appSettings} from '../../../../config';
const warehouseStockTable=appSettings.warehouse_db+'.stock';
const salesSoTable=appSettings.sales_db+'.sale_order';
const salesInvTable=appSettings.sales_db+'.so_invoice_details';
const coldStorageTable=appSettings.masters_db+'.zone_master';
const rackPositionTable=appSettings.masters_db+'.rack_position';
@ViewEntity({ 
  expression: `SELECT inv.po_number AS poNumber,so.sale_order_id as saleOrderId,so.sale_order_no AS saleOrderNumber,s.stock_id AS stockId,s.lot_no AS lotNo,s.total_cartons AS totalCartons,
  s.unit_id AS unitId,s.packing_completed AS packingCompleted,z.zone_name AS coldStorage,r.rack_code AS rackPosition,s.location AS stockLocationId,
  s.pallet_code AS palletCode,b.brand_name AS brandName,p.name AS productName,
  sc.variant_code AS variantCode,s.min_grade AS minGrade,s.max_grade AS maxGrade,concat(s.min_grade,'-',s.max_grade) as grade,s.state AS stockState,s.date as stockDate FROM `+warehouseStockTable+` s 
  LEFT JOIN `+salesInvTable+` inv ON inv.sale_order_id=s.sale_order_id 
  LEFT JOIN `+salesSoTable+` so ON so.sale_order_id=s.sale_order_id 
  LEFT JOIN `+coldStorageTable+` z ON z.zone_id=s.zone_id
  LEFT JOIN `+rackPositionTable+` r ON r.rack_Position_id=s.location
  LEFT JOIN `+appSettings.masters_db+`.brands b ON b.brand_id=s.brand_id
  LEFT JOIN `+appSettings.masters_db+`.products p ON p.product_id=s.product_id
  LEFT JOIN `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id=s.varient_id
  where s.status='StockIn'
  `
})
export class StockView {

  @ViewColumn()
  stockId: number;

  @ViewColumn()
  lotNo: string;

  @ViewColumn()
  poNumber: string;
  @ViewColumn()
  saleOrderId:number;

  @ViewColumn()
  saleOrderNumber: string;

  @ViewColumn()
  totalCartons: string;

  @ViewColumn()
  rackPosition: string;
  
  @ViewColumn()
  unitId: number;

  @ViewColumn()
  packingCompleted: string;
  @ViewColumn()
  coldStorage: string;
  
  @ViewColumn()
  stockLocationId:number;

  @ViewColumn()
  palletCode:number;
  @ViewColumn()
  brandName:string;
  @ViewColumn()
  productName:string;
  @ViewColumn()
  variantCode:string;
  @ViewColumn()
  minGrade:string;
  @ViewColumn()
  maxGrade:string;
  @ViewColumn()
  stockState:string;
  @ViewColumn()
  grade:string;
  @ViewColumn()
  stockDate:Date;
}